import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  Box,
  Button,
  Paper,
  InputBase,
  IconButton,
  Skeleton,
  Tabs,
  Tab,
} from "@mui/material";
import React, { useEffect, useState, Suspense } from "react";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { rem } from "assets/js/common";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import SelectStore from "components/notice/select-store";
import { useDispatch, useSelector } from "react-redux";
import { reset, loadNoticeListAction } from "redux/reducers/notice/index";
import { loadAction } from "redux/reducers/top";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { useParams, useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  notice: {
    "& .board-list": {
      paddingBottom: rem(38),
      "& .item": {
        "& > a": {
          padding: `${rem(22)} ${rem(30)}`,
          "& .title-group": {
            lineHeight: rem(20),
            "& .title": {
              lineHeight: rem(20),
            },
            "& .ico-new": {
              width: rem(15),
              height: rem(15),
              backgroundSize: `${rem(15)} ${rem(15)}`,
            },
          },
          "& .board-info": {
            marginTop: rem(4),
            "& .date": {
              letterSpacing: "-0.2px",
            },
          },
        },
      },
    },
    "& .ico-filter": {
      marginBottom: rem(2),
    },
    "& .MuiButton-text": {
      lineHeight: rem(22),
    },
  },
}));

export default function NoticeList(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { schForm, noticeList, loading } = useSelector((state) => state.notice);
  const [storeList, setStoreList] = useState([]);

  const [val, setVal] = useState(0);
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState({
    list: [],
  });
  const [initialized, setInitialized] = useState(true);
  const history = useHistory();

  const handleChangeTab = (event, newValue) => {
    setVal(newValue);
    dispatch(
      loadNoticeListAction({
        ...schForm,
        pg: 1,
        schTp: newValue + 1,
        schStore: "",
      })
    );
  };

  const handleInfiniteScroll = () => {
    if (schForm.pg >= rows.totalPageSize) {
      setInitialized(false);
      return;
    }

    dispatch(
      loadNoticeListAction({
        ...schForm,
        pg: schForm.pg + 1,
      })
    );
  };

  const isNew = (rgstYmd) => {
    let today = moment();
    let rgst = moment(rgstYmd);
    return today.diff(rgst, "days") <= 7;
  };

  const handleSelectStoreOpen = () => {
    setOpen(true);
  };

  // useEffect(() => {
  //   alert(JSON.stringify(schForm));
  //   dispatch(loadNoticeListAction(schForm));
  // }, [schForm]);

  useEffect(() => {
    if (noticeList) {
      if (schForm.pg == 1) {
        console.log("setRows", rows);
        setRows(noticeList);
      } else {
        setRows({ ...noticeList, list: [...rows.list, ...noticeList.list] });
      }
    }
  }, [noticeList]);

  const loadStoreList = () => {
    let store = "";
    axios
      .get(`/api/st/store-code`, {
        params: {
          tp: "",
          useYn: "Y",
        },
      })
      .then((res) => {
        if (res.data.data) setStoreList(res.data.data);
      });
    return store;
  };

  const getStoreNm = (cd) => {
    let find = storeList.find((store) => store.cd == cd);
    return find ? find.nm : "";
  };

  useEffect(() => {
    // alert(JSON.stringify(schForm));
    dispatch(loadNoticeListAction(schForm));
    loadStoreList();

    return () => {
      dispatch(reset());
    };
  }, []);
  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "공지사항", menu: true }));
  }, [init]);

  const handleRefresh = () => {
    return new Promise((resolve) => {
      dispatch(
        loadNoticeListAction({
          ...schForm,
          pg: 1,
        })
      );
      resolve(noticeList);
    });
  };

  window.appBackKeyHandle = () => {
    if (open) {
      setOpen(false);
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Loading open={loading ? true : false} />
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent={false}
        refreshingContent={<Spinner />}
        resistance={3}
      >
        <main id="main" className={"container nopad " + classes.notice}>
          <Tabs
            value={val}
            onChange={handleChangeTab}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="메가마트" />
            <Tab label="메가마켓" />
          </Tabs>
          <Box className="box-type-1">
            <Button
              color="primary"
              variant="text"
              onClick={handleSelectStoreOpen}
            >
              {getStoreNm(schForm.schStore) || "전체매장"}
              <i className="ico-filter" />
            </Button>
          </Box>
          {
            // loading && rows.list.length == 0 ? (
            //   <div className="board-list">
            //     {Array.from(Array(6)).map((_, index) => (
            //       <>
            //         <div className="item">
            //           <Box p={6} pt={0}>
            //             <Skeleton height={30} />
            //             <Skeleton height={30} width={100} />
            //           </Box>
            //         </div>
            //       </>
            //     ))}
            //   </div>
            // ) :
            <InfiniteScroll
              dataLength={rows.list.length}
              next={handleInfiniteScroll}
              hasMore={setInitialized}
              inverse={false}
              loader={loading && <Loading />}
            >
              <div className="board-list">
                <>
                  {rows.list.length == 0 && (
                    <>
                      <div className="nodata mt15">
                        <Box className="illust">
                          <img
                            src={`${
                              process.env.PUBLIC_URL
                            }/images/icon/nodata.svg`}
                          />
                        </Box>
                        <p className="color-info">조회된 내역이 없습니다</p>
                      </div>
                    </>
                  )}
                  {rows.list.map((item, i) => (
                    <div className="item" key={i}>
                      <Link to={`/notice/detail/${item.seq}`}>
                        <div className="title-group">
                          <p className="title ellipsis">{item.ttl}</p>
                          {isNew(item.rgstYmd) && <i className="ico-new" />}
                        </div>
                        <div className="board-info">
                          <span className="date">{item.formatRgstYmd}</span>
                          <span className="place">
                            {getStoreNm(item.store) || "전체"}
                          </span>
                        </div>
                      </Link>
                    </div>
                  ))}
                </>
              </div>
            </InfiniteScroll>
          }
          <SelectStore open={open} setOpen={setOpen} />
        </main>
      </PullToRefresh>
    </>
  );
}
